import { Game, GameKind, SwiperConfiguration } from "../../gql/graphql";

export type SwiperGame = Omit<Game, "configuration"> & {
  configuration: SwiperConfiguration;
};
export function isSwiperGame(game?: Game | null): game is SwiperGame {
  return game?.kind === GameKind.Swiper;
}
